<app-dialog
    [dialogWithInput]="dialog"
    [manualCloseManagement]="false">
    <div class="row">
        <div class="col-12" *ngIf="token.additionalAccounts.length > 0">
            <app-card-v2 title="Vos comptes clients">
                <div class="row">
                    <app-form-field label="Choisissez un de vos comptes" size="12">
                        <app-select-filter [elements]="additionalAccountElements"
                                           [filterElementProcessor]="filterAccount" [parentFormGroup]="formGroupAdditionalAccount"
                                           parentFormControlName="account">
                            <ng-template let-element='element' template-content>
                                {{element.name}}
                            </ng-template>
                        </app-select-filter>
                    </app-form-field>
                    <div class="col-12 text-right">
                        <app-button fill="solid" color="primary" label="Choisir ce compte" [disabled]="!formGroupAdditionalAccount.valid" (clickEvent)="selectAccount(formGroupAdditionalAccount.get('account').value)"></app-button>
                    </div>
                </div>
            </app-card-v2>
        </div>
        <div class="col-12" *ngIf="token.providers.length > 0">
            <app-card-v2 title="Vos comptes fournisseurs">
                <div class="row">
                    <app-form-field label="Compte fournisseur" size="12">
                        <app-select-filter [elements]="providerAccountElements" (_onSingleSelectionChange)="providerSelected($event)"
                                           [filterElementProcessor]="filterProvider" [parentFormGroup]="formGroupCustomerAccount"
                                           parentFormControlName="providerAccount">
                            <ng-template let-element='element' template-content>
                                {{element.name}}
                            </ng-template>
                        </app-select-filter>
                    </app-form-field>
                </div>
                <div class="row" *ngIf="formGroupCustomerAccount.get('providerAccount').value">
                    <app-form-field label="Filtre" size="12">
                        <app-input-text [parentFormGroup]="formGroupCustomerAccount" parentFormControlName="accountName"
                                        (keyPressedEvent)="accountNameChanged()"></app-input-text>
                    </app-form-field>
                    <app-form-field label="Comptes clients disponibles" size="12">
                        <app-paginated-list-data
                                [paginatedService]="service"
                                [parameters]="subscriptionParameters"
                                noResultLabel="Aucun compte client disponible"
                                [sort]="subscriptionSort">
                            <ng-template let-element='element' template-content>
                                <app-item [entity]="element">
                                    <app-summary>
                                        <ng-container title>
                                            {{element.accountName}} - {{element.providerServiceName}}
                                        </ng-container>
                                    </app-summary>
                                    <app-button buttons fill="solid"
                                                color="primary"
                                                label="Choisir"
                                                (clickEvent)="selectSubscription(element)" [loading]="findOneService.loading$ | async">
                                    </app-button>
                                </app-item>
                            </ng-template>
                        </app-paginated-list-data>
                    </app-form-field>
                </div>
            </app-card-v2>
        </div>
    </div>
</app-dialog>
